@if (isLoading) {
  <loader [config]="loaderConfig"></loader>
}

<div class="card meeting-minute-form-card">
  <div class="card-header d-flex align-items-center gap-2">
    <h3 class="card-title mb-0">{{ pageTitle }}</h3>
  </div>

  <div class="card-body">
    <meeting-minute-form
      [meetingMinute]="meetingMinute"
      [meetingMinuteId]="meetingMinuteId"
      [loaderContext]="LOADER_CONTEXT"
      (onSavedData)="onFormSavedData($event)">
    </meeting-minute-form>
  </div>
</div>
